<script setup lang="ts">
import {
  Activity,
  Alarm,
  AntennaSignal,
  City,
  CodeBrackets,
  AlignCenter,
  AlignHorizontalCenters,
  AlignJustify,
  AlignLeft,
  AlignLeftBox,
  AlignRight,
  AlignRightBox,
  ArrowDown,
  ArrowRight,
  ArrowUp,
  Barcode,
  Bell,
  BirthdayCake,
  Bold,
  Bookmark,
  BubbleStar,
  Calendar,
  CalendarCheck,
  Clock,
  Coins,
  Community,
  Compress,
  Copy,
  CrackedEgg,
  CursorPointer,
  Donate,
  DoubleCheck,
  Drag,
  EditPencil,
  EmojiPuzzled,
  Eye,
  EyeClosed,
  Facebook,
  Female,
  FilterList,
  Gift,
  Globe,
  GoogleCircle,
  GraduationCap,
  HalfMoon,
  Healthcare,
  HistoricShield,
  IconoirProvider,
  Infinite,
  InfoCircle,
  Instagram,
  Italic,
  LayoutLeft,
  Linkedin,
  List,
  LongArrowDownRight,
  Lullaby,
  Magnet,
  Mail,
  Male,
  Medal1st,
  Message,
  NavArrowDown,
  Notes,
  NumberedListLeft,
  Palette,
  Pause,
  PeaceHand,
  Plus,
  RefreshCircle,
  Repeat,
  SendMail,
  SendMailSolid,
  Shop,
  ShopFourTiles,
  Star,
  Text,
  TextSize,
  TextSquare,
  Tiktok,
  Trash,
  Trophy,
  Underline,
  User,
  UserBag,
  UserCrown,
  UserLove,
  UserPlus,
  UserStar,
  WarningTriangle,
  X,
  Xmark,
  Youtube,
  UserXmark,
  ScanBarcode,
  ShoppingBag,
  Euro,
  Cart
} from '@iconoir/vue'
import {
  AcademicCapIcon as AcademicCapIconOutline,
  AdjustmentsVerticalIcon as AdjustmentsVerticalIconOutline,
  ArrowDownCircleIcon as ArrowDownCircleIconOutline,
  ArrowDownOnSquareIcon as ArrowDownOnSquareIconOutline,
  ArrowDownTrayIcon as ArrowDownTrayIconOutline,
  ArrowLeftOnRectangleIcon as ArrowLeftOnRectangleIconOutline,
  ArrowLongDownIcon as ArrowLongDownIconOutline,
  ArrowLongRightIcon as ArrowLongRightIconOutline,
  ArrowLongUpIcon as ArrowLongUpIconOutline,
  ArrowPathIcon as ArrowPathIconOutline,
  ArrowRightIcon as ArrowRightIconOutline,
  ArrowRightOnRectangleIcon as ArrowRightOnRectangleIconOutline,
  ArrowsRightLeftIcon as ArrowsRightLeftIconOutline,
  ArrowTopRightOnSquareIcon as ArrowTopRightOnSquareIconOutline,
  ArrowTrendingUpIcon as ArrowTrendingUpIconOutline,
  ArrowUpCircleIcon as ArrowUpCircleIconOutline,
  ArrowUpTrayIcon as ArrowUpTrayIconOutline,
  AtSymbolIcon as AtSymbolIconOutline,
  Bars3BottomLeftIcon as Bars3BottomLeftIconOutline,
  BellAlertIcon as BellAlertIconOutline,
  BellIcon as BellIconOutline,
  BoltIcon as BoltIconOutline,
  BriefcaseIcon as BriefcaseIconOutline,
  BuildingOfficeIcon as BuildingOfficeIconOutline,
  BuildingStorefrontIcon as BuildingStorefrontIconOutline,
  CakeIcon as CakeIconOutline,
  CalculatorIcon as CalculatorIconOutline,
  CalendarIcon as CalendarIconOutline,
  ChartBarIcon as ChartBarIconOutline,
  ChartBarSquareIcon as ChartBarSquareIconOutline,
  ChartPieIcon as ChartPieIconOutline,
  ChatBubbleBottomCenterTextIcon as ChatBubbleBottomCenterTextIconOutline,
  ChatBubbleLeftEllipsisIcon as ChatBubbleLeftEllipsisIconOutline,
  ChatBubbleLeftIcon as ChatBubbleLeftIconOutline,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconOutline,
  ChatBubbleOvalLeftEllipsisIcon as ChatBubbleOvalLeftEllipsisIconOutline,
  CheckCircleIcon as CheckCircleIconOutline,
  CheckIcon as CheckIconOutline,
  ChevronLeftIcon as ChevronLeftIconOutline,
  ChevronRightIcon as ChevronRightIconOutline,
  ChevronUpDownIcon as ChevronUpDownIconOutline,
  CircleStackIcon as CircleStackIconOutline,
  ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconOutline,
  ClipboardDocumentIcon as ClipboardDocumentIconOutline,
  ClipboardDocumentListIcon as ClipboardDocumentListIconOutline,
  ClipboardIcon as ClipboardIconOutline,
  ClockIcon as ClockIconOutline,
  CloudArrowUpIcon as CloudArrowUpIconOutline,
  Cog6ToothIcon as Cog6ToothIconOutline,
  Cog8ToothIcon as Cog8ToothIconOutline,
  CogIcon as CogIconOutline,
  ComputerDesktopIcon as ComputerDesktopIconOutline,
  CurrencyEuroIcon as CurrencyEuroIconOutline,
  DevicePhoneMobileIcon as DevicePhoneMobileIconOutline,
  DeviceTabletIcon as DeviceTabletIconOutline,
  DocumentIcon as DocumentIconOutline,
  DocumentMagnifyingGlassIcon as DocumentMagnifyingGlassIconOutline,
  DocumentPlusIcon as DocumentPlusIconOutline,
  EnvelopeIcon as EnvelopeIconOutline,
  ExclamationCircleIcon as ExclamationCircleIconOutline,
  ExclamationTriangleIcon as ExclamationTriangleIconOutline,
  EyeDropperIcon as EyeDropperIconOutline,
  EyeIcon as EyeIconOutline,
  FlagIcon as FlagIconOutline,
  FunnelIcon as FunnelIconOutline,
  GiftIcon as GiftIconOutline,
  GlobeAltIcon as GlobeAltIconOutline,
  HandRaisedIcon as HandRaisedIconOutline,
  HeartIcon as HeartIconOutline,
  HomeIcon as HomeIconOutline,
  IdentificationIcon as IdentificationIconOutline,
  InboxIcon as InboxIconOutline,
  InformationCircleIcon as InformationCircleIconOutline,
  LifebuoyIcon as LifebuoyIconOutline,
  LightBulbIcon as LightBulbIconOutline,
  LinkIcon as LinkIconOutline,
  LockClosedIcon as LockClosedIconOutline,
  LockOpenIcon as LockOpenIconOutline,
  MagnifyingGlassIcon as MagnifyingGlassIconOutline,
  MapPinIcon as MapPinIconOutline,
  MegaphoneIcon as MegaphoneIconOutline,
  MinusSmallIcon as MinusSmallIconOutline,
  MoonIcon as MoonIconOutline,
  PaintBrushIcon as PaintBrushIconOutline,
  PencilIcon as PencilIconOutline,
  PencilSquareIcon as PencilSquareIconOutline,
  PhoneXMarkIcon as PhoneXMarkIconOutline,
  PlusCircleIcon as PlusCircleIconOutline,
  PlusIcon as PlusIconOutline,
  PlusSmallIcon as PlusSmallIconOutline,
  QrCodeIcon as QrCodeIconOutline,
  QuestionMarkCircleIcon as QuestionMarkCircleIconOutline,
  RectangleStackIcon as RectangleStackIconOutline,
  ShieldCheckIcon as ShieldCheckIconOutline,
  ShoppingBagIcon as ShoppingBagIconOutline,
  SparklesIcon as SparklesIconOutline,
  Square3Stack3DIcon as Square3Stack3DIconOutline,
  SquaresPlusIcon as SquaresPlusIconOutline,
  StarIcon as StarIconOutline,
  SwatchIcon as SwatchIconOutline,
  TagIcon as TagIconOutline,
  TrashIcon as TrashIconOutline,
  TrophyIcon as TrophyIconOutline,
  TruckIcon as TruckIconOutline,
  UserCircleIcon as UserCircleIconOutline,
  UserGroupIcon as UserGroupIconOutline,
  UserIcon as UserIconOutline,
  UsersIcon as UsersIconOutline,
  WalletIcon as WalletIconOutline,
  XCircleIcon as XCircleIconOutline,
  XMarkIcon as XMarkIconOutline
} from '@heroicons/vue/24/outline'
import {
  AdjustmentsVerticalIcon as AdjustmentsVerticalIconSolid,
  ArrowDownCircleIcon as ArrowDownCircleIconSolid,
  ArrowDownTrayIcon as ArrowDownTrayIconSolid,
  ArrowLeftIcon as ArrowLeftIconSolid,
  ArrowLongRightIcon as ArrowLongRightIconSolid,
  ArrowLongUpIcon as ArrowLongUpIconSolid,
  PaintBrushIcon as PaintBrushIconSolid,
  ArrowPathIcon as ArrowPathIconSolid,
  ArrowPathRoundedSquareIcon as ArrowPathRoundedSquareIconSolid,
  ArrowRightIcon as ArrowRightIconSolid,
  ArrowsPointingOutIcon as ArrowsPointingOutIconSolid,
  ArrowsRightLeftIcon as ArrowsRightLeftIconSolid,
  ArrowsUpDownIcon as ArrowsUpDownIconSolid,
  ArrowTopRightOnSquareIcon as ArrowTopRightOnSquareIconSolid,
  ArrowTrendingUpIcon as ArrowTrendingUpIconSolid,
  ArrowUpCircleIcon as ArrowUpCircleIconSolid,
  ArrowUturnLeftIcon as ArrowUturnLeftIconSolid,
  BellIcon as BellIconSolid,
  BoltIcon as BoltIconSolid,
  BuildingOfficeIcon as BuildingOfficeIconSolid,
  BuildingStorefrontIcon as BuildingStorefrontIconSolid,
  CalculatorIcon as CalculatorIconSolid,
  ChartBarIcon as ChartBarIconSolid,
  ChartPieIcon as ChartPieIconSolid,
  ChatBubbleBottomCenterTextIcon as ChatBubbleBottomCenterTextIconSolid,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid,
  ChatBubbleOvalLeftEllipsisIcon as ChatBubbleOvalLeftEllipsisIconSolid,
  CheckBadgeIcon as CheckBadgeIconSolid,
  CheckCircleIcon as CheckCircleIconSolid,
  CheckIcon as CheckIconSolid,
  ChevronDoubleRightIcon as ChevronDoubleRightIconSolid,
  ChevronDownIcon as ChevronDownIconSolid,
  ChevronLeftIcon as ChevronLeftIconSolid,
  ChevronRightIcon as ChevronRightIconSolid,
  ChevronUpDownIcon as ChevronUpDownIconSolid,
  CircleStackIcon as CircleStackIconSolid,
  ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconSolid,
  ClipboardDocumentIcon as ClipboardDocumentIconSolid,
  ClipboardIcon as ClipboardIconSolid,
  ClockIcon as ClockIconSolid,
  CloudArrowUpIcon as CloudArrowUpIconSolid,
  CogIcon as CogIconSolid,
  CreditCardIcon as CreditCardIconSolid,
  CubeIcon as CubeIconSolid,
  CursorArrowRaysIcon as CursorArrowRaysIconSolid,
  DocumentArrowDownIcon as DocumentArrowDownIconSolid,
  DocumentChartBarIcon as DocumentChartBarIconSolid,
  DocumentPlusIcon as DocumentPlusIconSolid,
  DocumentTextIcon as DocumentTextIconSolid,
  EllipsisHorizontalIcon as EllipsisHorizontalIconSolid,
  EnvelopeIcon as EnvelopeIconSolid,
  ExclamationCircleIcon as ExclamationCircleIconSolid,
  ExclamationTriangleIcon as ExclamationTriangleIconSolid,
  EyeIcon as EyeIconSolid,
  EyeSlashIcon as EyeSlashIconSolid,
  FaceFrownIcon as FaceFrownIconSolid,
  FlagIcon as FlagIconSolid,
  GiftIcon as GiftIconSolid,
  GlobeAltIcon as GlobeAltIconSolid,
  HeartIcon as HeartIconSolid,
  HomeIcon as HomeIconSolid,
  IdentificationIcon as IdentificationIconSolid,
  InboxIcon as InboxIconSolid,
  InformationCircleIcon as InformationCircleIconSolid,
  LinkIcon as LinkIconSolid,
  LockClosedIcon as LockClosedIconSolid,
  LockOpenIcon as LockOpenIconSolid,
  MagnifyingGlassIcon as MagnifyingGlassIconSolid,
  MapPinIcon as MapPinIconSolid,
  MegaphoneIcon as MegaphoneIconSolid,
  MicrophoneIcon as MicrophoneIconSolid,
  MinusIcon as MinusIconSolid,
  NewspaperIcon as NewspaperIconSolid,
  NoSymbolIcon as NoSymbolIconSolid,
  PaperAirplaneIcon as PaperAirplaneIconSolid,
  PauseIcon as PauseIconSolid,
  PencilIcon as PencilIconSolid,
  PencilSquareIcon as PencilSquareIconSolid,
  PhoneIcon as PhoneIconSolid,
  PhoneXMarkIcon as PhoneXMarkIconSolid,
  PhotoIcon as PhotoIconSolid,
  PlayIcon as PlayIconSolid,
  PlusCircleIcon as PlusCircleIconSolid,
  PlusIcon as PlusIconSolid,
  PresentationChartLineIcon as PresentationChartLineIconSolid,
  QrCodeIcon as QrCodeIconSolid,
  QuestionMarkCircleIcon as QuestionMarkCircleIconSolid,
  ReceiptPercentIcon as ReceiptPercentIconSolid,
  ReceiptRefundIcon as ReceiptRefundIconSolid,
  RectangleGroupIcon as RectangleGroupIconSolid,
  RocketLaunchIcon as RocketLaunchIconSolid,
  ShoppingCartIcon as ShoppingCartIconSolid,
  SparklesIcon as SparklesIconSolid,
  Square2StackIcon as Square2StackIconSolid,
  Square3Stack3DIcon as Square3Stack3DIconSolid,
  SquaresPlusIcon as SquaresPlusIconSolid,
  StarIcon as StarIconSolid,
  StopIcon as StopIconSolid,
  SwatchIcon as SwatchIconSolid,
  TrashIcon as TrashIconSolid,
  TrophyIcon as TrophyIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  UserIcon as UserIconSolid,
  UserPlusIcon as UserPlusIconSolid,
  UsersIcon as UsersIconSolid,
  VariableIcon as VariableIconSolid,
  WalletIcon as WalletIconSolid,
  XCircleIcon as XCircleIconSolid,
  XMarkIcon as XMarkIconSolid
} from '@heroicons/vue/20/solid'

import {
  BoltIcon as BoltIconSolid24,
  BuildingStorefrontIcon as BuildingStorefrontIconSolid24,
  ChartPieIcon as ChartPieIconSolid24,
  ChatBubbleBottomCenterTextIcon as ChatBubbleBottomCenterTextIconSolid24,
  CircleStackIcon as CircleStackIconSolid24,
  ClipboardDocumentListIcon as ClipboardDocumentListIconSolid24,
  GiftIcon as GiftIconSolid24,
  HeartIcon as HeartIconSolid24,
  HomeIcon as HomeIconSolid24,
  LinkIcon as LinkIconSolid24,
  LockClosedIcon as LockClosedIconSolid24,
  MegaphoneIcon as MegaphoneIconSolid24,
  PhoneXMarkIcon as PhoneXMarkIconSolid24,
  SparklesIcon as SparklesIconSolid24,
  SquaresPlusIcon as SquaresPlusIconSolid24,
  TrophyIcon as TrophyIconSolid24,
  UserGroupIcon as UserGroupIconSolid24
} from '@heroicons/vue/24/solid'

const props = withDefaults(
  defineProps<{
    strokeWidth?: number
    name: Icons
  }>(),
  {
    strokeWidth: 1.5
  }
)
const icons = {
  IconoirActivity: markRaw(Activity),
  IconoirAlarm: markRaw(Alarm),
  IconoirAntennaSignal: markRaw(AntennaSignal),
  IconoirCity: markRaw(City),
  IconoirCodeBrackets: markRaw(CodeBrackets),
  IconoirAlignCenter: markRaw(AlignCenter),
  IconoirAlignHorizontalCenters: markRaw(AlignHorizontalCenters),
  IconoirAlignJustify: markRaw(AlignJustify),
  IconoirAlignLeft: markRaw(AlignLeft),
  IconoirAlignLeftBox: markRaw(AlignLeftBox),
  IconoirAlignRight: markRaw(AlignRight),
  IconoirAlignRightBox: markRaw(AlignRightBox),
  IconoirArrowDown: markRaw(ArrowDown),
  IconoirArrowRight: markRaw(ArrowRight),
  IconoirArrowUp: markRaw(ArrowUp),
  IconoirBarCode: markRaw(Barcode),
  IconoirBell: markRaw(Bell),
  IconoirBirthdayCake: markRaw(BirthdayCake),
  IconoirBold: markRaw(Bold),
  IconoirBookmark: markRaw(Bookmark),
  IconoirBubbleStar: markRaw(BubbleStar),
  IconoirCalendar: markRaw(Calendar),
  IconoirCalendarCheck: markRaw(CalendarCheck),
  IconoirCart: markRaw(Cart),
  IconoirClock: markRaw(Clock),
  IconoirCoins: markRaw(Coins),
  IconoirCommunity: markRaw(Community),
  IconoirCompress: markRaw(Compress),
  IconoirCopy: markRaw(Copy),
  IconoirCrackedEgg: markRaw(CrackedEgg),
  IconoirCursorPointer: markRaw(CursorPointer),
  IconoirDonate: markRaw(Donate),
  IconoirDoubleCheck: markRaw(DoubleCheck),
  IconoirDrag: markRaw(Drag),
  IconoirEditPencil: markRaw(EditPencil),
  IconoirEmojiPuzzled: markRaw(EmojiPuzzled),
  IconoirEuro: markRaw(Euro),
  IconoirEye: markRaw(Eye),
  IconoirEyeClosed: markRaw(EyeClosed),
  IconoirFacebook: markRaw(Facebook),
  IconoirFemale: markRaw(Female),
  IconoirFilterList: markRaw(FilterList),
  IconoirGift: markRaw(Gift),
  IconoirGlobe: markRaw(Globe),
  IconoirGoogleCircle: markRaw(GoogleCircle),
  IconoirGraduationCap: markRaw(GraduationCap),
  IconoirHalfMoon: markRaw(HalfMoon),
  IconoirHealthcare: markRaw(Healthcare),
  IconoirHistoricShield: markRaw(HistoricShield),
  IconoirInfinite: markRaw(Infinite),
  IconoirInfoCircle: markRaw(InfoCircle),
  IconoirInstagram: markRaw(Instagram),
  IconoirItalic: markRaw(Italic),
  IconoirLayoutLeft: markRaw(LayoutLeft),
  IconoirLinkedin: markRaw(Linkedin),
  IconoirList: markRaw(List),
  IconoirLongArrowDownRight: markRaw(LongArrowDownRight),
  IconoirLullaby: markRaw(Lullaby),
  IconoirMagnet: markRaw(Magnet),
  IconoirMail: markRaw(Mail),
  IconoirMale: markRaw(Male),
  IconoirMedal1st: markRaw(Medal1st),
  IconoirMessage: markRaw(Message),
  IconoirNavArrowDown: markRaw(NavArrowDown),
  IconoirNotes: markRaw(Notes),
  IconoirNumberedListLeft: markRaw(NumberedListLeft),
  IconoirPalette: markRaw(Palette),
  IconoirPause: markRaw(Pause),
  IconoirPeaceHand: markRaw(PeaceHand),
  IconoirPlus: markRaw(Plus),
  IconoirRefreshCircle: markRaw(RefreshCircle),
  IconoirRepeat: markRaw(Repeat),
  IconoirSendMail: markRaw(SendMail),
  IconoirSendMailOutline: markRaw(SendMail),
  IconoirSendMailSolid: markRaw(SendMailSolid),
  IconoirShop: markRaw(Shop),
  IconoirShoppingBag: markRaw(ShoppingBag),
  IconoirShopFourTiles: markRaw(ShopFourTiles),
  IconoirStar: markRaw(Star),
  IconoirScanBarcode: markRaw(ScanBarcode),
  IconoirText: markRaw(Text),
  IconoirTextSize: markRaw(TextSize),
  IconoirTextSquare: markRaw(TextSquare),
  IconoirTiktok: markRaw(Tiktok),
  IconoirTrash: markRaw(Trash),
  IconoirTrophy: markRaw(Trophy),
  IconoirUnderline: markRaw(Underline),
  IconoirUser: markRaw(User),
  IconoirUserBag: markRaw(UserBag),
  IconoirUserCrown: markRaw(UserCrown),
  IconoirUserLove: markRaw(UserLove),
  IconoirUserPlus: markRaw(UserPlus),
  IconoirUserStar: markRaw(UserStar),
  IconoirUserXmark: markRaw(UserXmark),
  IconoirWarningTriangle: markRaw(WarningTriangle),
  IconoirX: markRaw(X),
  IconoirXMark: markRaw(Xmark),
  IconoirYoutube: markRaw(Youtube)
}
const heroIconsSolid = {
  HeroAdjustmentsVerticalIconSolid: markRaw(AdjustmentsVerticalIconSolid),
  HeroArrowDownCircleIconSolid: markRaw(ArrowDownCircleIconSolid),
  HeroArrowDownTrayIconSolid: markRaw(ArrowDownTrayIconSolid),
  HeroArrowLeftIconSolid: markRaw(ArrowLeftIconSolid),
  HeroArrowLongRightIconSolid: markRaw(ArrowLongRightIconSolid),
  HeroArrowLongUpIconSolid: markRaw(ArrowLongUpIconSolid),
  HeroArrowPathIconSolid: markRaw(ArrowPathIconSolid),
  HeroArrowPathRoundedSquareIconSolid: markRaw(ArrowPathRoundedSquareIconSolid),
  HeroArrowRightIconSolid: markRaw(ArrowRightIconSolid),
  HeroArrowsPointingOutIconSolid: markRaw(ArrowsPointingOutIconSolid),
  HeroArrowsRightLeftIconSolid: markRaw(ArrowsRightLeftIconSolid),
  HeroArrowsUpDownIconSolid: markRaw(ArrowsUpDownIconSolid),
  HeroArrowTopRightOnSquareIconSolid: markRaw(ArrowTopRightOnSquareIconSolid),
  HeroArrowTrendingUpIconSolid: markRaw(ArrowTrendingUpIconSolid),
  HeroArrowUpCircleIconSolid: markRaw(ArrowUpCircleIconSolid),
  HeroArrowUturnLeftIconSolid: markRaw(ArrowUturnLeftIconSolid),
  HeroBellIconSolid: markRaw(BellIconSolid),
  HeroBoltIconSolid: markRaw(BoltIconSolid),
  HeroBuildingOfficeIconSolid: markRaw(BuildingOfficeIconSolid),
  HeroBuildingStorefrontIconSolid: markRaw(BuildingStorefrontIconSolid),
  HeroCalculatorIconSolid: markRaw(CalculatorIconSolid),
  HeroChartBarIconSolid: markRaw(ChartBarIconSolid),
  HeroChartPieIconSolid: markRaw(ChartPieIconSolid),
  HeroChatBubbleBottomCenterTextIconSolid: markRaw(ChatBubbleBottomCenterTextIconSolid),
  HeroChatBubbleLeftRightIconSolid: markRaw(ChatBubbleLeftRightIconSolid),
  HeroChatBubbleOvalLeftEllipsisIconSolid: markRaw(ChatBubbleOvalLeftEllipsisIconSolid),
  HeroCheckBadgeIconSolid: markRaw(CheckBadgeIconSolid),
  HeroCheckCircleIconSolid: markRaw(CheckCircleIconSolid),
  HeroCheckIconSolid: markRaw(CheckIconSolid),
  HeroChevronDoubleRightIconSolid: markRaw(ChevronDoubleRightIconSolid),
  HeroChevronDownIconSolid: markRaw(ChevronDownIconSolid),
  HeroChevronLeftIconSolid: markRaw(ChevronLeftIconSolid),
  HeroChevronRightIconSolid: markRaw(ChevronRightIconSolid),
  HeroChevronUpDownIconSolid: markRaw(ChevronUpDownIconSolid),
  HeroCircleStackIconSolid: markRaw(CircleStackIconSolid),
  HeroClipboardDocumentCheckIconSolid: markRaw(ClipboardDocumentCheckIconSolid),
  HeroClipboardDocumentIconSolid: markRaw(ClipboardDocumentIconSolid),
  HeroClipboardIconSolid: markRaw(ClipboardIconSolid),
  HeroClockIconSolid: markRaw(ClockIconSolid),
  HeroCloudArrowUpIconSolid: markRaw(CloudArrowUpIconSolid),
  HeroCogIconSolid: markRaw(CogIconSolid),
  HeroCreditCardIconSolid: markRaw(CreditCardIconSolid),
  HeroCubeIconSolid: markRaw(CubeIconSolid),
  HeroCursorArrowRaysIconSolid: markRaw(CursorArrowRaysIconSolid),
  HeroDocumentArrowDownIconSolid: markRaw(DocumentArrowDownIconSolid),
  HeroDocumentChartBarIconSolid: markRaw(DocumentChartBarIconSolid),
  HeroDocumentPlusIconSolid: markRaw(DocumentPlusIconSolid),
  HeroDocumentTextIconSolid: markRaw(DocumentTextIconSolid),
  HeroEllipsisHorizontalIconSolid: markRaw(EllipsisHorizontalIconSolid),
  HeroEnvelopeIconSolid: markRaw(EnvelopeIconSolid),
  HeroExclamationCircleIconSolid: markRaw(ExclamationCircleIconSolid),
  HeroExclamationTriangleIconSolid: markRaw(ExclamationTriangleIconSolid),
  HeroEyeIconSolid: markRaw(EyeIconSolid),
  HeroEyeSlashIconSolid: markRaw(EyeSlashIconSolid),
  HeroFaceFrownIconSolid: markRaw(FaceFrownIconSolid),
  HeroFlagIconSolid: markRaw(FlagIconSolid),
  HeroGiftIconSolid: markRaw(GiftIconSolid),
  HeroGlobeAltIconSolid: markRaw(GlobeAltIconSolid),
  HeroHeartIconSolid: markRaw(HeartIconSolid),
  HeroHomeIconSolid: markRaw(HomeIconSolid),
  HeroIdentificationIconSolid: markRaw(IdentificationIconSolid),
  HeroInboxIconSolid: markRaw(InboxIconSolid),
  HeroInformationCircleIconSolid: markRaw(InformationCircleIconSolid),
  HeroLinkIconSolid: markRaw(LinkIconSolid),
  HeroLockClosedIconSolid: markRaw(LockClosedIconSolid),
  HeroLockOpenIconSolid: markRaw(LockOpenIconSolid),
  HeroMagnifyingGlassIconSolid: markRaw(MagnifyingGlassIconSolid),
  HeroMapPinIconSolid: markRaw(MapPinIconSolid),
  HeroMegaphoneIconSolid: markRaw(MegaphoneIconSolid),
  HeroMicrophoneIconSolid: markRaw(MicrophoneIconSolid),
  HeroMinusIconSolid: markRaw(MinusIconSolid),
  HeroNewspaperIconSolid: markRaw(NewspaperIconSolid),
  HeroNoSymbolIconSolid: markRaw(NoSymbolIconSolid),
  HeroPaperAirplaneIconSolid: markRaw(PaperAirplaneIconSolid),
  HeroPauseIconSolid: markRaw(PauseIconSolid),
  HeroPencilIconSolid: markRaw(PencilIconSolid),
  HeroPencilSquareIconSolid: markRaw(PencilSquareIconSolid),
  HeroPhoneIconSolid: markRaw(PhoneIconSolid),
  HeroPaintBrushIconSolid: markRaw(PaintBrushIconSolid),
  HeroPhoneXMarkIconSolid: markRaw(PhoneXMarkIconSolid),
  HeroPhotoIconSolid: markRaw(PhotoIconSolid),
  HeroPlayIconSolid: markRaw(PlayIconSolid),
  HeroPlusCircleIconSolid: markRaw(PlusCircleIconSolid),
  HeroPlusIconSolid: markRaw(PlusIconSolid),
  HeroPresentationChartLineIconSolid: markRaw(PresentationChartLineIconSolid),
  HeroQrCodeIconSolid: markRaw(QrCodeIconSolid),
  HeroQuestionMarkCircleIconSolid: markRaw(QuestionMarkCircleIconSolid),
  HeroReceiptPercentIconSolid: markRaw(ReceiptPercentIconSolid),
  HeroReceiptRefundIconSolid: markRaw(ReceiptRefundIconSolid),
  HeroRectangleGroupIconSolid: markRaw(RectangleGroupIconSolid),
  HeroRocketLaunchIconSolid: markRaw(RocketLaunchIconSolid),
  HeroShoppingCartIconSolid: markRaw(ShoppingCartIconSolid),
  HeroSparklesIconSolid: markRaw(SparklesIconSolid),
  HeroSquare2StackIconSolid: markRaw(Square2StackIconSolid),
  HeroSquare3Stack3DIconSolid: markRaw(Square3Stack3DIconSolid),
  HeroSquaresPlusIconSolid: markRaw(SquaresPlusIconSolid),
  HeroStarIconSolid: markRaw(StarIconSolid),
  HeroStopIconSolid: markRaw(StopIconSolid),
  HeroSwatchIconSolid: markRaw(SwatchIconSolid),
  HeroTrashIconSolid: markRaw(TrashIconSolid),
  HeroTrophyIconSolid: markRaw(TrophyIconSolid),
  HeroUserGroupIconSolid: markRaw(UserGroupIconSolid),
  HeroUserIconSolid: markRaw(UserIconSolid),
  HeroUserPlusIconSolid: markRaw(UserPlusIconSolid),
  HeroUsersIconSolid: markRaw(UsersIconSolid),
  HeroVariableIconSolid: markRaw(VariableIconSolid),
  HeroWalletIconSolid: markRaw(WalletIconSolid),
  HeroXCircleIconSolid: markRaw(XCircleIconSolid),
  HeroXMarkIconSolid: markRaw(XMarkIconSolid)
}
const heroIconsOutline = {
  HeroAcademicCapIconOutline: markRaw(AcademicCapIconOutline),
  HeroAdjustmentsVerticalIconOutline: markRaw(AdjustmentsVerticalIconOutline),
  HeroArrowDownCircleIconOutline: markRaw(ArrowDownCircleIconOutline),
  HeroArrowDownOnSquareIconOutline: markRaw(ArrowDownOnSquareIconOutline),
  HeroArrowDownTrayIconOutline: markRaw(ArrowDownTrayIconOutline),
  HeroArrowLeftOnRectangleIconOutline: markRaw(ArrowLeftOnRectangleIconOutline),
  HeroArrowLongDownIconOutline: markRaw(ArrowLongDownIconOutline),
  HeroArrowLongRightIconOutline: markRaw(ArrowLongRightIconOutline),
  HeroArrowLongUpIconOutline: markRaw(ArrowLongUpIconOutline),
  HeroArrowPathIconOutline: markRaw(ArrowPathIconOutline),
  HeroArrowRightIconOutline: markRaw(ArrowRightIconOutline),
  HeroArrowRightOnRectangleIconOutline: markRaw(ArrowRightOnRectangleIconOutline),
  HeroArrowsRightLeftIconOutline: markRaw(ArrowsRightLeftIconOutline),
  HeroArrowTopRightOnSquareIconOutline: markRaw(ArrowTopRightOnSquareIconOutline),
  HeroArrowTrendingUpIconOutline: markRaw(ArrowTrendingUpIconOutline),
  HeroArrowUpCircleIconOutline: markRaw(ArrowUpCircleIconOutline),
  HeroArrowUpTrayIconOutline: markRaw(ArrowUpTrayIconOutline),
  HeroAtSymbolIconOutline: markRaw(AtSymbolIconOutline),
  HeroBars3BottomLeftIconOutline: markRaw(Bars3BottomLeftIconOutline),
  HeroBellAlertIconOutline: markRaw(BellAlertIconOutline),
  HeroBellIconOutline: markRaw(BellIconOutline),
  HeroBoltIconOutline: markRaw(BoltIconOutline),
  HeroBriefcaseIconOutline: markRaw(BriefcaseIconOutline),
  HeroBuildingOfficeIconOutline: markRaw(BuildingOfficeIconOutline),
  HeroBuildingStorefrontIconOutline: markRaw(BuildingStorefrontIconOutline),
  HeroCakeIconOutline: markRaw(CakeIconOutline),
  HeroCalculatorIconOutline: markRaw(CalculatorIconOutline),
  HeroCalendarIconOutline: markRaw(CalendarIconOutline),
  HeroChartBarIconOutline: markRaw(ChartBarIconOutline),
  HeroChartBarSquareIconOutline: markRaw(ChartBarSquareIconOutline),
  HeroChartPieIconOutline: markRaw(ChartPieIconOutline),
  HeroChatBubbleBottomCenterTextIconOutline: markRaw(ChatBubbleBottomCenterTextIconOutline),
  HeroChatBubbleLeftEllipsisIconOutline: markRaw(ChatBubbleLeftEllipsisIconOutline),
  HeroChatBubbleLeftIconOutline: markRaw(ChatBubbleLeftIconOutline),
  HeroChatBubbleLeftRightIconOutline: markRaw(ChatBubbleLeftRightIconOutline),
  HeroChatBubbleOvalLeftEllipsisIconOutline: markRaw(ChatBubbleOvalLeftEllipsisIconOutline),
  HeroCheckCircleIconOutline: markRaw(CheckCircleIconOutline),
  HeroCheckIconOutline: markRaw(CheckIconOutline),
  HeroChevronLeftIconOutline: markRaw(ChevronLeftIconOutline),
  HeroChevronRightIconOutline: markRaw(ChevronRightIconOutline),
  HeroChevronUpDownIconOutline: markRaw(ChevronUpDownIconOutline),
  HeroCircleStackIconOutline: markRaw(CircleStackIconOutline),
  HeroClipboardDocumentCheckIconOutline: markRaw(ClipboardDocumentCheckIconOutline),
  HeroClipboardDocumentIconOutline: markRaw(ClipboardDocumentIconOutline),
  HeroClipboardDocumentListIconOutline: markRaw(ClipboardDocumentListIconOutline),
  HeroClipboardIconOutline: markRaw(ClipboardIconOutline),
  HeroClockIconOutline: markRaw(ClockIconOutline),
  HeroCloudArrowUpIconOutline: markRaw(CloudArrowUpIconOutline),
  HeroCog6ToothIconOutline: markRaw(Cog6ToothIconOutline),
  HeroCog8ToothIconOutline: markRaw(Cog8ToothIconOutline),
  HeroCogIconOutline: markRaw(CogIconOutline),
  HeroComputerDesktopIconOutline: markRaw(ComputerDesktopIconOutline),
  HeroCurrencyEuroIconOutline: markRaw(CurrencyEuroIconOutline),
  HeroDevicePhoneMobileIconOutline: markRaw(DevicePhoneMobileIconOutline),
  HeroDeviceTabletIconOutline: markRaw(DeviceTabletIconOutline),
  HeroDocumentIconOutline: markRaw(DocumentIconOutline),
  HeroDocumentMagnifyingGlassIconOutline: markRaw(DocumentMagnifyingGlassIconOutline),
  HeroDocumentPlusIconOutline: markRaw(DocumentPlusIconOutline),
  HeroEnvelopeIconOutline: markRaw(EnvelopeIconOutline),
  HeroExclamationCircleIconOutline: markRaw(ExclamationCircleIconOutline),
  HeroExclamationTriangleIconOutline: markRaw(ExclamationTriangleIconOutline),
  HeroEyeDropperIconOutline: markRaw(EyeDropperIconOutline),
  HeroEyeIconOutline: markRaw(EyeIconOutline),
  HeroFlagIconOutline: markRaw(FlagIconOutline),
  HeroFunnelIconOutline: markRaw(FunnelIconOutline),
  HeroGiftIconOutline: markRaw(GiftIconOutline),
  HeroGlobeAltIconOutline: markRaw(GlobeAltIconOutline),
  HeroHandRaisedIconOutline: markRaw(HandRaisedIconOutline),
  HeroHeartIconOutline: markRaw(HeartIconOutline),
  HeroHomeIconOutline: markRaw(HomeIconOutline),
  HeroIdentificationIconOutline: markRaw(IdentificationIconOutline),
  HeroInboxIconOutline: markRaw(InboxIconOutline),
  HeroInformationCircleIconOutline: markRaw(InformationCircleIconOutline),
  HeroLifebuoyIconOutline: markRaw(LifebuoyIconOutline),
  HeroLightBulbIconOutline: markRaw(LightBulbIconOutline),
  HeroLinkIconOutline: markRaw(LinkIconOutline),
  HeroLockClosedIconOutline: markRaw(LockClosedIconOutline),
  HeroLockOpenIconOutline: markRaw(LockOpenIconOutline),
  HeroMagnifyingGlassIconOutline: markRaw(MagnifyingGlassIconOutline),
  HeroMapPinIconOutline: markRaw(MapPinIconOutline),
  HeroMegaphoneIconOutline: markRaw(MegaphoneIconOutline),
  HeroMinusSmallIconOutline: markRaw(MinusSmallIconOutline),
  HeroMoonIconOutline: markRaw(MoonIconOutline),
  HeroPaintBrushIconOutline: markRaw(PaintBrushIconOutline),
  HeroPencilIconOutline: markRaw(PencilIconOutline),
  HeroPencilSquareIconOutline: markRaw(PencilSquareIconOutline),
  HeroPhoneXMarkIconOutline: markRaw(PhoneXMarkIconOutline),
  HeroPlusCircleIconOutline: markRaw(PlusCircleIconOutline),
  HeroPlusIconOutline: markRaw(PlusIconOutline),
  HeroPlusSmallIconOutline: markRaw(PlusSmallIconOutline),
  HeroQrCodeIconOutline: markRaw(QrCodeIconOutline),
  HeroQuestionMarkCircleIconOutline: markRaw(QuestionMarkCircleIconOutline),
  HeroRectangleStackIconOutline: markRaw(RectangleStackIconOutline),
  HeroShieldCheckIconOutline: markRaw(ShieldCheckIconOutline),
  HeroShoppingBagIconOutline: markRaw(ShoppingBagIconOutline),
  HeroSquare3Stack3DIconOutline: markRaw(Square3Stack3DIconOutline),
  HeroSparklesIconOutline: markRaw(SparklesIconOutline),
  HeroSquaresPlusIconOutline: markRaw(SquaresPlusIconOutline),
  HeroStarIconOutline: markRaw(StarIconOutline),
  HeroSwatchIconOutline: markRaw(SwatchIconOutline),
  HeroTagIconOutline: markRaw(TagIconOutline),
  HeroTrashIconOutline: markRaw(TrashIconOutline),
  HeroTrophyIconOutline: markRaw(TrophyIconOutline),
  HeroTruckIconOutline: markRaw(TruckIconOutline),
  HeroUserCircleIconOutline: markRaw(UserCircleIconOutline),
  HeroUserGroupIconOutline: markRaw(UserGroupIconOutline),
  HeroUserIconOutline: markRaw(UserIconOutline),
  HeroUsersIconOutline: markRaw(UsersIconOutline),
  HeroWalletIconOutline: markRaw(WalletIconOutline),
  HeroXCircleIconOutline: markRaw(XCircleIconOutline),
  HeroXMarkIconOutline: markRaw(XMarkIconOutline)
}
const heroIconsSolid24 = {
  HeroBoltIconSolid24: markRaw(BoltIconSolid24),
  HeroBuildingStorefrontIconSolid24: markRaw(BuildingStorefrontIconSolid24),
  HeroChartPieIconSolid24: markRaw(ChartPieIconSolid24),
  HeroChatBubbleBottomCenterTextIconSolid24: markRaw(ChatBubbleBottomCenterTextIconSolid24),
  HeroCircleStackIconSolid24: markRaw(CircleStackIconSolid24),
  HeroClipboardDocumentListIconSolid24: markRaw(ClipboardDocumentListIconSolid24),
  HeroGiftIconSolid24: markRaw(GiftIconSolid24),
  HeroHeartIconSolid24: markRaw(HeartIconSolid24),
  HeroHomeIconSolid24: markRaw(HomeIconSolid24),
  HeroLinkIconSolid24: markRaw(LinkIconSolid24),
  HeroLockClosedIconSolid24: markRaw(LockClosedIconSolid24),
  HeroMegaphoneIconSolid24: markRaw(MegaphoneIconSolid24),
  HeroPhoneXMarkIconSolid24: markRaw(PhoneXMarkIconSolid24),
  HeroSparklesIconSolid24: markRaw(SparklesIconSolid24),
  HeroSquaresPlusIconSolid24: markRaw(SquaresPlusIconSolid24),
  HeroTrophyIconSolid24: markRaw(TrophyIconSolid24),
  HeroUserGroupIconSolid24: markRaw(UserGroupIconSolid24)
}

export type Icons =
  | keyof typeof icons
  | keyof typeof heroIconsSolid
  | keyof typeof heroIconsOutline
  | keyof typeof heroIconsSolid24

const icon = computed(() => {
  if (props.name in icons) {
    return icons[props.name]
  }
  if (props.name in heroIconsSolid) {
    return heroIconsSolid[props.name]
  }
  if (props.name in heroIconsOutline) {
    return heroIconsOutline[props.name]
  }
  if (props.name in heroIconsSolid24) {
    return heroIconsSolid24[props.name]
  }
  const outlineFallback = props.name.replace(/IconSolid24$/, 'IconOutline')
  if (outlineFallback !== props.name && outlineFallback in heroIconsOutline) {
    return heroIconsOutline[outlineFallback as keyof typeof heroIconsOutline]
  }

  console.error(`Icon ${props.name} not found`)

  return null
})

const isIconoir = computed(() => {
  return props.name in icons
})

const isHeroIcon = computed(() => {
  return props.name in heroIconsSolid || props.name in heroIconsOutline || props.name in heroIconsSolid24
})

defineExpose({
  icon: icon.value
})
</script>

<template>
  <div v-if="icon" :data-icon-name="name">
    <IconoirProvider
      v-if="isIconoir && icon"
      :icon-props="{
        'stroke-width': strokeWidth
      }"
    >
      <component :is="icon" aria-hidden="true" :class="['size-full', $attrs.class || 'text-foreground-secondary']" />
    </IconoirProvider>
    <component
      :is="icon"
      v-else-if="isHeroIcon && icon"
      aria-hidden="true"
      class="size-full"
      :style="{ strokeWidth: strokeWidth }"
    />
  </div>
</template>
